import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=722de10d"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports